import { render, staticRenderFns } from "./CustomizationSubmenu.vue?vue&type=template&id=642b36a6&"
import script from "./CustomizationSubmenu.vue?vue&type=script&lang=js&"
export * from "./CustomizationSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./CustomizationSubmenu.vue?vue&type=style&index=0&id=642b36a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports